export default "__VITE_ASSET__cYtKppxc__"